export default __webpack_public_path__ + "static/media/l3.067dab4c.jpg";